(function () {
  function syncExpandedState(item) {
    var summary = item.querySelector('summary');
    if (summary) {
      summary.setAttribute('aria-expanded', item.open ? 'true' : 'false');
    }
  }

  function initFaq(root) {
    root.querySelectorAll('details[data-faq-item]').forEach(syncExpandedState);
    root.addEventListener('toggle', function (event) {
      if (event.target.matches('details[data-faq-item]')) {
        syncExpandedState(event.target);
      }
    }, true);

    root.addEventListener('click', function (event) {
      var link = event.target.closest('a[href^="#faq-category-"]');
      if (!link) return;

      var target = document.querySelector(link.getAttribute('href'));
      if (!target) return;

      // The legacy theme also binds to in-page links and focuses the target,
      // which can scroll a second time after the browser's default anchor jump.
      event.preventDefault();
      event.stopImmediatePropagation();

      var header = document.querySelector('#header .header__content');
      var headerOffset = header ? header.getBoundingClientRect().height : 0;
      var targetTop = target.getBoundingClientRect().top + window.pageYOffset - headerOffset - 16;
      var prefersReducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      window.scrollTo({
        top: Math.max(0, targetTop),
        behavior: prefersReducedMotion ? 'auto' : 'smooth'
      });

      if (window.history && window.history.replaceState) {
        window.history.replaceState(null, '', link.getAttribute('href'));
      }
    }, true);
  }

  document.querySelectorAll('[data-section-type="faq-native"]').forEach(initFaq);
})();
